import React from 'react';

import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import { endOfToday, formatDistanceStrict } from 'date-fns';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import isFuture from 'date-fns/isFuture';
import styled, { css } from 'styled-components';
import { StyledTypography, StyledTooltip } from 'styles/common';

import { convertDateToString4, getColorFromKey } from 'constants/helper';
import { StyledIcon } from 'constants/icons';

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props?.size === 'big' ? '0.5rem 1rem' : '0.25rem 0.5rem')};
  &:hover {
    cursor: ${(props) => (props?.clickable === false ? 'default' : 'pointer')};
  }
  height: 32px;
  min-width: 64px;
  border-radius: 3px;
`;

export function DateNotPresentDisplay(props) {
  return (
    <>
      <StyledIcon color="currentColor" size="tiny">
        <DateRangeOutlinedIcon />
      </StyledIcon>
      <StyledTypography color="inherit" display="inline" variant="body2" leftGutter={0.25} {...props}>
        Add
      </StyledTypography>
    </>
  );
}

export function DatePresentDisplay({ date, className, ...props }) {
  return (
    <StyledTypography
      className={className}
      color="inherit"
      display="inline"
      variant="body2"
      leftGutter={0.25}
      {...props}
    >
      {convertDateToString4(date)}
    </StyledTypography>
  );
}

export function RelativeDateDisplay({ date, className, ...props }) {
  return (
    <StyledTypography
      className={className}
      color="inherit"
      display="inline"
      variant="body2"
      leftGutter={0.25}
      {...props}
    >
      {!date && 'Add date'}
      {date && formatDistanceToNow(new Date(date)) + (isFuture(date) ? ' left' : ' ago')}
    </StyledTypography>
  );
}

export function RelativeDateDueInDisplay({ date, className, ...props }) {
  return (
    <StyledTypography
      className={className}
      color="inherit"
      display="inline"
      variant="body2"
      leftGutter={0.25}
      {...props}
    >
      Due in {date && formatDistanceStrict(endOfToday(), date)}
    </StyledTypography>
  );
}

export default function DateField({ children, tooltip = '', className, ...props }) {
  if (!tooltip) {
    return (
      <Container className={className} {...props}>
        {children}
      </Container>
    );
  }
  return (
    <StyledTooltip title={tooltip}>
      <Container className={className} {...props}>
        {children}
      </Container>
    </StyledTooltip>
  );
}

DateField.DateNotPresentDisplay = DateNotPresentDisplay;
DateField.DatePresentDisplay = DatePresentDisplay;
DateField.RelativeDateDisplay = RelativeDateDisplay;
DateField.RelativeDateDueInDisplay = RelativeDateDueInDisplay;

export const DueDateStyles = css`
  background-color: ${(props) => getColorFromKey(props.borderColor)}33;
  color: ${(props) => getColorFromKey(props.borderColor)};
`;

export const StyledDateField = styled(DateField)`
  ${DueDateStyles};
`;
